import React from "react";
import { Link } from "react-router-dom";
import "../css/contact.scss";
import { APP_STORE_URL, PLAY_STORE_URL } from "./AppDeepLink";

const Contact = ({ data }) => {
  const locationFlags = [
    { src: "/images/flags/mongolia.png", alt: "Mongolia" },
    { src: "/images/flags/uk.png", alt: "United Kingdom" },
  ];

  const renderLocation = (location) => {
    if (Array.isArray(location)) {
      return location.map((item, index) => {
        const flag = locationFlags[index];

        return (
          <span className="footer__address-line" key={index}>
            {flag && (
              <img
                alt={`${flag.alt} flag`}
                className="footer__address-flag"
                height={18}
                src={flag.src}
                width={24}
              />
            )}
            <span>{item}</span>
          </span>
        );
      });
    }

    return (
      <span className="footer__address-line">
        <img
          alt="Mongolia flag"
          className="footer__address-flag"
          height={18}
          src="/images/flags/mongolia.png"
          width={24}
        />
        <span>{location}</span>
      </span>
    );
  };

  const renderSocialIcon = (href, src, alt) => {
    if (!href) {
      return null;
    }

    return (
      <a href={href} target="_blank" rel="noopener noreferrer" aria-label={alt}>
        <img src={src} alt={alt} width={20} height={20} />
      </a>
    );
  };

  const buildFooterLinks = (links = []) => {
    const legalLinks = [
      { link: "/privacy", name: data.privacyPolicy || "Privacy Policy" },
      { link: "/terms", name: data.termsOfUse || "Terms of Use" },
    ];
    const otherLinks = links.filter(
      (item) => item.link !== "/privacy" && item.link !== "/terms"
    );

    return [...otherLinks, ...legalLinks];
  };

  const footerLinks = buildFooterLinks(data.links);
  const footerMobileLinks = buildFooterLinks(data.mobileLinks || data.links);

  const renderLink = (item, index) => {
    if (item.link.startsWith("http")) {
      return (
        <a
          key={index}
          href={item.link}
          target="_blank"
          rel="noopener noreferrer"
        >
          {item.name}
        </a>
      );
    }
    return (
      <Link key={index} to={item.link}>
        {item.name}
      </Link>
    );
  };

  return (
    <footer className="footer" id="contact">
      <div className="footer__separator" />
      <div className="footer__inner">
        <img
          alt="Tomko"
          className="footer__logo"
          src="/images/tomko_logo_color.png"
          width={218}
          height={63}
        />

        {/* Desktop layout */}
        <div className="footer__columns">
          <section className="footer__col">
            <h3 className="footer__heading">{data.address}</h3>
            <p className="footer__text">{renderLocation(data.location)}</p>
          </section>
          <section className="footer__col">
            <h3 className="footer__heading">{data.contactUs}</h3>
            <div className="footer__text">
              <span>
                {data.mail}: {data.mailAddress}
              </span>
              {!data.phoneHidden && data.phoneNum && (
                <span>
                  {data.phone}: {data.phoneNum}
                </span>
              )}
              <span>{data.workhours}</span>
              <span>
                {renderSocialIcon(
                  data.facebookAddress,
                  "/images/facebook.png",
                  "Facebook"
                )}
                {" "}
                {renderSocialIcon(
                  data.instagramAddress,
                  "/images/instagram.png",
                  "Instagram"
                )}
              </span>
            </div>
          </section>
          <section className="footer__col">
            <h3 className="footer__heading">{data.link}</h3>
            <div className="footer__links">
              {footerLinks.map((item, index) => renderLink(item, index))}
            </div>
          </section>
        </div>

        {/* Mobile layout */}
        <div className="footer__mobile">
          <section className="footer__mobile-section">
            <h3 className="footer__heading">{data.address}</h3>
            <p className="footer__text">{renderLocation(data.location)}</p>
          </section>
          <section className="footer__mobile-section">
            <h3 className="footer__heading">{data.contactUs}</h3>
            <div className="footer__text">
              <span>
                {data.mail}: {data.mailAddress}
              </span>
              {!data.phoneHidden && data.phoneNum && (
                <span>
                  {data.phone}: {data.phoneNum}
                </span>
              )}
              <span>{data.workhours}</span>
              <span>
                {renderSocialIcon(
                  data.facebookAddress,
                  "/images/facebook.png",
                  "Facebook"
                )}
                {" "}
                {renderSocialIcon(
                  data.instagramAddress,
                  "/images/instagram.png",
                  "Instagram"
                )}
              </span>
            </div>
          </section>
          <section className="footer__mobile-section">
            <h3 className="footer__heading">{data.link}</h3>
            <div className="footer__links">
              {footerMobileLinks.map((item, index) => renderLink(item, index))}
            </div>
          </section>
          <div className="footer__app-buttons">
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Get it on Google Play"
            >
              <img
                src="/images/android.png"
                alt="Get it on Google Play"
                width={135}
                height={45}
              />
            </a>
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Download on the App Store"
            >
              <img
                src="/images/ios.png"
                alt="Download on the App Store"
                width={135}
                height={45}
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Contact;
